import { Link } from '@inertiajs/react';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, CardContent, Button } from '../../../components/ui';

function SeriesCard({ s }) {
  return (
    <Card className="flex flex-col hover:shadow-md transition-shadow">
      <CardContent className="flex-1 p-5">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white line-clamp-2 leading-snug">
            {s.name}
          </h3>
          {!s.is_own && (
            <span className="flex-shrink-0 text-xs text-gray-400 dark:text-gray-500 mt-0.5">shared</span>
          )}
        </div>

        {s.author && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">by {s.author}</p>
        )}

        {s.description && (
          <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-2 mb-3">
            {s.description}
          </p>
        )}

        <p className="text-xs text-gray-400 dark:text-gray-500 mb-4">
          {s.book_count === 1 ? '1 book' : `${s.book_count} books`}
        </p>

        <Link href={`/teacher/book_series/${s.id}`}>
          <Button variant="secondary" size="sm">View series</Button>
        </Link>
      </CardContent>
    </Card>
  );
}

export default function BookSeriesIndex({ series = [] }) {
  return (
    <TeacherShell scrollTitle="Book Series">
      <TeacherPageHeader
        title="Book Series"
        subtitle="Group library books into series for easier navigation."
        actions={
          <Link href="/teacher/book_series/new">
            <Button variant="primary">New series</Button>
          </Link>
        }
      />

      {series.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-gray-500 dark:text-gray-400 mb-4">
            No series yet. Create one to group related books together.
          </p>
          <Link href="/teacher/book_series/new">
            <Button variant="primary">Create your first series</Button>
          </Link>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {series.map((s) => (
            <SeriesCard key={s.id} s={s} />
          ))}
        </div>
      )}
    </TeacherShell>
  );
}
